import { ComponentCommunicationService } from '../../component-communication.service';
import { FontTypeEnum } from 'src/app/model/enums/FontTypeEnum';
import { ConfigSettingDto } from '../../model/business/ConfigSettingDto';
import { SessionService } from 'src/app/session-service.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EnumConverterService } from 'src/app/services/EnumConverterService';
import { OptionsEnum } from 'src/app/model/enums/OptionsEnum';
import { FormGroup } from '@angular/forms';
import { InsuredAttributesDto } from 'src/app/model/business/calculation/InsuredAttributesDto';
import { Constants } from '../../constants';

@Component({
  selector: 'app-calculation-insured-component',
  templateUrl: './calculation-insured.component.html',
  styleUrls: ['./calculation-insured.component.css'],
})
export class CalculationInsuredComponent implements OnInit {
  model: InsuredAttributesDto = new InsuredAttributesDto();
  yesNoList = this.enumConverterService.toBaseList('OptionsEnum', OptionsEnum);
  FontTypeEnum = FontTypeEnum;
  @Input()
  formGroup: FormGroup;

  @Input()
  inputBorderColor: string;

  @Input()
  inputColor: string;

  @Input()
  secondInsured: boolean;

  @Output()
  insuredDataChanged = new EventEmitter<void>();

  thousandSeparator = Constants.THOUSAND_SEPARATOR;

  dateMask: string;
  placeholderInsurer = {
    dateOfBirth: 'CalculationInsurer.DateOfBirth',
    sumAssured: 'CalculationInsurer.SumAssured',
    isSmoker: 'CalculationInsurer.IsSmoker'
  };

  configSettingsDto: ConfigSettingDto;

  constructor(
    private enumConverterService: EnumConverterService,
    public sessionService: SessionService,
    private componentCommunication: ComponentCommunicationService
  ) { }


  ngOnInit(): void {
    if (this.secondInsured) {
      this.getPlaceholderForInsurer();
      this.formGroup.get('sumAssured').patchValue(this.componentCommunication.latestSumInsured);
    }
  }

  emitUpdateEvent(): void {
    this.insuredDataChanged.emit();
  }

  get dateMaskFormat(): string {
    return this.componentCommunication.getDateFormat();
  }

  onKey(): void {
    if (!this.secondInsured) {
      this.componentCommunication.changeSum
        .emit(this.formGroup.get('sumAssured').value);
    }
  }

  private getPlaceholderForInsurer(): void {
    this.placeholderInsurer.dateOfBirth = 'CalculationInsurer.DateOfBirthSecond';
    this.placeholderInsurer.sumAssured = 'CalculationInsurer.SumAssuredSecond';
    this.placeholderInsurer.isSmoker = 'CalculationInsurer.IsSmokerSecond';
  }
}
